export default __webpack_public_path__ + "static/media/mediTransmit.964e4744.svg";